import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=7cfa9b9b&scoped=true"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa9b9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cfa9b9b')) {
      api.createRecord('7cfa9b9b', component.options)
    } else {
      api.reload('7cfa9b9b', component.options)
    }
    module.hot.accept("./Location.vue?vue&type=template&id=7cfa9b9b&scoped=true", function () {
      api.rerender('7cfa9b9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/components/Location.vue"
export default component.exports